import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import { withRouter, RouteComponentProps } from 'react-router';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import HashLink from '../Common/HashLink';

const jss = (theme: Theme) => createStyles({
    list: {
        width: '100%',
    },
});

interface Props extends RouteComponentProps {
    quizzes: Bee.Quiz[];
    classes: {
        list: string;
    };
}

class ScoresList extends React.Component<Props, any> {
  	render() {
        const { classes } = this.props;
        return (
            <List className={classes.list}>
                <Divider />
                {this.props.quizzes.map(row => (
                    <ListItem
                        key={row.id}
                        button
                        divider
                        component={HashLink}
                        // @ts-ignore
                        to={`${this.props.match.path}/${row.id}`}
                    >   
                        <ListItemText primary={row.title} primaryTypographyProps={{ align: 'center' }} />
                    </ListItem>
                ))}
            </List>
        );
	}
}

export default withRouter(withStyles(jss)(ScoresList));



// WEBPACK FOOTER //
// ./src/components/Score/ScoresList.tsx